<template>
  <div class="my-upload" :class="{uploaded: uploadedSwitch}">
    <el-upload v-bind="$attrs" class="upload-demo" :class="{'upload-picture': listType != 'text'}" :action="ossUrl" :data="ossData" :limit="0" :on-success="uploaded" :show-file-list="true" :on-change="uploadCfg" :list-type="listType" :on-remove="remove" :file-list="fileList" :accept="accept">
      <el-button v-if="listType == 'text'" type="primary">点击上传</el-button>
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <div v-if="info" slot="tip" class="el-upload__tip">{{info}}</div>
  </div>
</template>

<script>
import API from '../../lib/API'
export default {
  name: 'my-upload',
  components: {},
  props: {
    info: {
      type: String
    },
    accept: {
      type: String,
      default: 'image/png,image/jpeg'
    },
    imgKey: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    listType: {
      type: String,
      default: 'picture-card'
    },
  },
  data() {
    return {
      ossUrl: '',
      ossData: {},
      key: '',
      uploadedSwitch: false,
      fileList: []
    }
  },
  created() {
    this.getOss()
    if (this.url) {
      this.fileList = [{ name: this.getFileName(this.url), url: this.url }]
    }
  },
  watch: {
    url() {
      this.fileList = [{ name: this.getFileName(this.url), url: this.url }]
    }
  },
  methods: {
    getFileName(str) {
      return str.split('/').pop()
    },
    getOss() {
      new API(this).POST({
        url: '/oss/getSignature',
        params: {
          count: 1,
          type: 5
        },
        cb: res => {
          this.ossUrl = res.url
          this.ossData = res.signatures[0]
        }
      })
    },
    uploadCfg(file) {
      this.uploadedSwitch = true
      let ext = file.raw.type
      ext = ext ? '.' + ext.split('/')[1] : ''
      if (ext.includes('msword')) {
        ext = '.doc'
      } else if (ext.includes('vnd.openxmlformats-officedocument.wordprocessingml.document')) {
        ext = '.docx'
      }
      let hasExt = this.ossData.key.indexOf('.')
      if (hasExt === -1) {
        this.ossData.key = this.ossData.key + ext
      } else {
        this.ossData.key = this.ossData.key.slice(0, hasExt)
        this.ossData.key += ext
      }
    },
    uploaded() {
      this.$emit('update:imgKey', this.ossData.key)
    },
    remove() {
      this.uploadedSwitch = false
      this.$emit('update:imgKey', '')
    }
  }
}
</script>

<style lang="less" scoped>
.my-upload{
  /deep/ ul {
    // display: block;
    // height:148px;
    line-height: 0;
    font-size:0;
  }
  /deep/ li {
    // animation: none!important;
    transition: none;
    margin: 0;
  }
  /deep/ .upload-picture {
    height: 148px;
    width: 148px;
    overflow: hidden;
  }
}
.uploaded /deep/ .el-upload.el-upload--picture-card {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/MyUpload.vue